import { IStackStyles, mergeStyles, ITextFieldStyles, IStackTokens, getTheme } from '@fluentui/react';

const palette = getTheme().palette;
export const fullHeightStyles: IStackStyles = {
  root: {
    height: '100%',
    overflowY: 'auto',
    marginTop: '70px',
    border: '1px solid #dbdbdb'
  }
};
export const paneFooterStyles: IStackStyles = {
  root: {
    marginBottom: '1.25rem'
  }
};
export const paneFooterTokens: IStackTokens = {
  childrenGap: '0.3125rem'
};
export const textFieldStyles: Partial<ITextFieldStyles> = {
  field: {
    color: palette.neutralSecondary,
    padding: 0
  },
  root: {
    marginLeft: '1rem',
    marginRight: '1rem'
  },
  fieldGroup: {
    border: 'none'
  }
};

export const paneHeaderStyle = mergeStyles({
  // height: '4.3125rem'
});
export const chatpaneHeaderStyle = mergeStyles({
  // height: '4.3125rem',
  // borderTop: '1px solid #a9a9a9',
});

export const paneHeaderTextStyle = mergeStyles({
  fontSize: '1.375rem',
  fontWeight: 600,
  // width: '69px',
  float: 'left',
  margin: '9px',
  color: '#fff'
});
export const footerMainTextStyle = mergeStyles({
  fontWeight: 600,
  fontSize: '1rem',
  marginLeft: '1rem',
  marginRight: '1rem'
});
export const copyLinkButtonStyle = mergeStyles({
  fontWeight: 600,
  fontSize: '0.875rem', // 14px
  // height: '2.5rem',
  // marginLeft: '1rem',
  // marginRight: '1rem',
  // width: '90%'
  margin: '0px',
  padding: '0px',
  minWidth: '35px',
  height: '29px'
});
export const copyIconStyle = mergeStyles({
  // marginRight: '0.5em'
});
export const settingsContainerStyle = mergeStyles({
  margin: '2px 12px;',
  // width: '15.375rem'
});
export const dropzone = mergeStyles({
  padding: '0px',
  border: 'dashed grey 4px',
  backgroundColor: 'rgba(255,255,255,.8)',
  color: '#bdbdbd',
  cursor: 'pointer',
  margin: '5px',
  minHeight: '80%',
  zIndex: 9999,
  position: 'absolute'
});
export const dragFiles = mergeStyles({
  position: 'absolute',
  top: '50%',
  textAlign: 'center',
  left: 0,
  right: 0,
  fontSize: '24px',
  color: 'grey',
  fontWeight: 500
});
export const loadingIcon = mergeStyles({
  padding: '0px',
  color: '#bdbdbd',
  cursor: 'pointer',
  margin: '5px',
  minHeight: '80%',
  zIndex: 9999,
  position: 'absolute'
});
export const loadinStyle = mergeStyles({
  position: 'absolute',
  top: '50%',
  textAlign: 'center',
  left: 0,
  right: 0,
  // fontSize: '24px',
  // color: 'grey',
  // fontWeight: 500,
  // display: 'inline-block',
  // width: '2rem',
  // height: '2rem',
  // verticalAlign: 'text-bottom',
  // border: '0.25em solid currentColor',
  // borderRightColor: 'transparent',
  // borderRadius: '50%',
  // animation: 'spinner-border .75s linear infinite'
});